import React, { Component  } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable  } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Tooltip  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
//import ModelDescription from './ModelDescription';
import { api, URL } from '../../api';
import Modelshowstudent from './Modelshowstudent';
import Modelteacherregister from './Modelteacherregister';
import Modelteacheraddstudent from './Modelteacheraddstudent';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Modelteacherregisterfile from './Modelteacherregisterfile';
import Modelteacheraddstudentshort from './Modelteacheraddstudentshort';
import Modelteacherregisterfileshort from './Modelteacherregisterfileshort';
//import ModelRegister from './ModelRegister';









//import Modaladdcurriculumopen from './Modaladdcurriculumopen';
//import Modeltest from './Modeltest';
//import Modaladdteacher from './Modaladdteacher';



export default class Teachercuriculumshort extends Component {
    
    constructor() {
        super();
        this.state = {

          modal: false,
         
          Shortcoursemd_Nameshort_TH:'',
          idcuriculum:'',
          studentlist:[],

          pagination: {
            current: 1,
            pageSize: 20,
          },

          idcuriculumshort:'',
          Shortcourse_ID:'',

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

      
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getCitizenstu = this.getCitizenstu.bind(this);
        this.removestudent = this.removestudent.bind(this);
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงนักศึกษาที่ลงทะเบียน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumstudentlistshort/'+this.state.idcuriculumshort,
            
             {headers: {
          
             }
             })
             //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
             .then(res => {
             // console.log(res.data[0].id)
             //  console.log(res.data)
             //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
             //  console.log(Course)
        
                const studentlist = res.data;
                 this.setState({ studentlist });
              }) 

           }, 0);
       }

      getCitizenstu() {
        setTimeout(() => {
           //ภายใน
           api.get('index/getCitizenstu/'+localStorage.getItem('Studentcb_ID'))
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ Citizen: res.data[0].Studentcb_Citizen_ID})
           }) 
         }, 0);
       }


       removestudent = (Studentcb_ID,Shortcoursemd_ID,Shortcourse_ID) => {

       // console.log(event.target.value);


        Swal.fire({
          title: 'ยืนยัน',
          text: "ยกเลิกการลงทะเบียนหรือไม่่",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
         cancelButtonText: 'ยกเลิก'
        }).then((result) => {
             if (result.isConfirmed) {
              //  Swal.fire('Saved!', '', 'success')
              //  this.toggle();
              console.log('ok')
              } else if (result.isDenied) {
               // Swal.fire('Changes are not saved', '', 'info')
              }
        })
     

       }



      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 

          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }





          componentDidMount(){
           
          const { id } = this.props.match.params; //idโมดูล
          const { id2 } = this.props.match.params; //id หลักสูตรระยะสั้น
          this.setState({ idcuriculumshort : id });
           this.setState({ Shortcourse_ID : id2 });
            if (localStorage.getItem('name') == null) {
               
                 // window.location.href = 'https://e-student.kpru.ac.th/vaccinekpru'
               
            } else {
        
            }
                      api.get('index/getCurriculumdetalshortmd/'+ id,
                      //   Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                      // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                         console.log(res.data[0].Shortcoursemd_Nameshort_TH)
                         this.setState({ Shortcoursemd_Nameshort_TH : res.data[0].Shortcoursemd_Nameshort_TH});

                       //   const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                       //  console.log(Course)
                          const Curriculum = res.data;
                          this.setState({ Curriculum });
                      })   
                      this.getCurriculumopen();
            }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };



       


    render() {

        console.log(this.state.Course_ID)
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const {  pagination } = this.state;
   
        const { Option } = Select;


        
        //ชุดตาราง
        const data = {
          columns: [
            {
              label: 'ลำดับ',
              field: 'name',
              sort: 'name',
              width: 150
            },
            {
              label: 'ชื่อ',
              field: 'username',
              sort: 'username',
              width: 270
            },
            {
              label: 'นามสกุล',
              field: 'LASTNAME',
              sort: 'LASTNAME',
              width: 200
            },
            {
              label: 'เบอร์โทร',
              field: 'TEL',
              sort: 'TEL',
              width: 100
            },
            {
              label: 'email',
              field: 'email',
              sort: 'email',
              width: 150
            },
            {
              label: 'จัดการ',
              field: 'metanan',
              sort: 'metanan',
              width: 150
            }
          ],

          rows: [...this.state.studentlist.map((data, i) => (
            {
               name: <>{i+1}</>,
               username: <>{data.FULLNAME}{data.Studentcb_NAME}</>,
               LASTNAME: <>{data.Studentcb_LASTNAME}</>,
               TEL: <>{data.Studentcb_TEL}</>,
               email: <>{data.Studentcb_EMAIL}</>,
               metanan: (()=> { 
                return <>  {<MDBBtn color="indigo" size="sm"   onClick={() => this.removestudent(data.Studentcb_ID ,data.Shortcoursemd_ID,data.Shortcourse_ID)}>ยกเลิกลงทะเบียน</MDBBtn>}</>
                 // if (<>data.Curriculumopen_Status_ONOFF === '1'</>) {
                 //   return <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  />
                 // }else{

                 // }

                 })(),
               random: <h5 searchvalue={data.Studentcb_NAME} >tourist <span className="badge badge-danger">narrow</span></h5>
              //  (()=>{
              //   if (personal.picture ==="") {
              //               return <img src={person} rounded  width='70px'  className="rounded  d-block" alt="aligment" />
              //              }if(personal.picture !==""){
                              
              //                return<MDBView hover zoom><ReactImageFallback
              //                      src={personal.picture} 
              //                      fallbackImage={person}
              //                      height='100px'
              //                      alt="cool image should be here"
              //                      className="rounded mx-auto d-block"
              //                      /></MDBView>
              //              }
              //              })(),
            }
           ))]
          
      
      };

      const persons = <MDBDataTable
     // searching ={true}
      searchLabel="ค้นหา ชื่อ,นามกสุล,เบอร์โทร"
      striped
      bordered
      small 
      entries={20}
     // entriesOptions={["10", "20"]}
      order={["age", "desc"]}
      data={data}
      entriesLabel="จำนวนที่แสดง "
      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
      responsive 
      sortRows={['random']}
/>
//ชุดตาราง

      const text = <span>ลงทะเบียน คือ "ลงทะเบียนผู้เรียนใหม่" เพิ่มผู้เรียน คือ "เพิ่มผู้เรียนในหลักสูตรระยะสั้น" </span>;
      const buttonWidth = 70;
       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
        <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> ลงทะเบียนผู้เรียน (สำหรับผู้สอนลงทะเบียนให้)</h4> } extra={<a href="#"><p>อาจารย์{localStorage.getItem('name')}</p></a>} >

            {/* <MDBRow>
                    <MDBCol sm="6">
                ค้นหารายวิชา  
                    <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกวิชา"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                           
                        
                        {this.state.Curriculum.map((Curriculum,index )  => 
                        <option value={Curriculum.Curriculumopen_ID}>{Curriculum.Curriculumopen_Full_Name_TH}</option>
                        )}
                        </Select>
                    </MDBCol>

                    <MDBCol sm="4">
                      
                    </MDBCol> 
               </MDBRow> */}

                        <Breadcrumb>
                          <Breadcrumb.Item>หน้าหลัก</Breadcrumb.Item>
                          <Breadcrumb.Item>
                            <a href="">ลงทะเบียนผู้เรียน</a>
                          </Breadcrumb.Item>
                         
                        </Breadcrumb>
                        <br/>

          
                 <MDBRow>
                        <MDBCol sm="12">
                            
                            <MDBJumbotron fluid>
                            <MDBContainer fluid>
                           <h2 className="display-5 deep-purple-text text-center">หลักสูตรระยะสั้น {this.state.Shortcoursemd_Nameshort_TH}</h2>
                                {/* <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4> */}
                              
                                <MDBCol>
                               <p className="text-right" >
                                {/* <Modelteacheraddstudent idcuriculum={this.state.idcuriculumshort} stulist={this.getCurriculumopen} /> */}
                                <Modelteacheraddstudentshort idcuriculum={this.state.idcuriculumshort} Shortcourse_ID={this.state.Shortcourse_ID} stulist={this.getCurriculumopen}  />
                                <Modelteacherregister/> 
                                <Modelteacherregisterfileshort idcuriculumshort={this.state.idcuriculumshort} Shortcourse_ID={this.state.Shortcourse_ID} stulist={this.getCurriculumopen} />
                                {/* <Modelteacherregisterfile idcuriculum={this.state.idcuriculum} stulist={this.getCurriculumopen} /> */}
                                    <Tooltip placement="top" title={text} color="orange">
                                    <MDBIcon icon="question-circle" size="lg" />
                                    </Tooltip>   
                               </p> 
                                   {/* ตาราง */}
                                   {persons} 

                                </MDBCol>
                            </MDBContainer>
                            </MDBJumbotron>    
                      
                        </MDBCol>
                 </MDBRow>
        </Card>
            </MDBContainer>
        )
    }
}
